module.exports = __webpack_public_path__ + "img/search.f6824236.svg";